import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ActivityProviderService } from '../activity-provider.service';
import { ActivityProvider } from '../activity-provider';

@Component({
    selector: 'app-activity-provider',
    templateUrl: './activity-provider.component.html',
    styleUrls: ['./activity-provider.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ActivityProviderComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private activityProviderService: ActivityProviderService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.activityProvider = data.activityProvider,
			this.statuses = activityProviderService.statuses;
	}

	@Input() activityProvider: ActivityProvider;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	activityProviderId: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'activityProviderId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'opsNotes': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		'billingType': [],
		'publicDesc': [],
		'contractDate': [],
	};
	
	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole activityProvider object
		if (this.activityProvider) {
			this.activityProviderId = this.activityProvider.activityProviderId;
			this.fixDates();
			this.form1.patchValue(this.activityProvider);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.activityProviderId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.activityProviderService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.activityProvider = res.data.activityProvider;
						this.doAdd.emit(this.activityProvider);
					},
					(err: any) => {
						console.log('activityProvider-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('activityProvider: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.activityProviderService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.activityProvider = res.data.activityProvider;
						this.doUpdate.emit(this.activityProvider);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.activityProviderService.delete(this.activityProvider.activityProviderId)
				.subscribe(
					(res: any) => {
						console.log('activityProvider-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.activityProvider);
					},
					(err: any) => {
						console.log('activityProvider-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			activityProviderId: [this.activityProviderId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			opsNotes: [],
			status: [],
			billingType: [],
			publicDesc: [],
			contractDate: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.activityProvider.activityProviderDate = moment(this.activityProvider.activityProviderDate).toDate();
	}
	
	closeDialog(event: any) {
		this.doAdd.emit(this.activityProvider);
	}
}
